import React, { useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { AuthContext } from "../contexts/AuthContext";
import { ScreenContext } from "../contexts/ScreenContext";

import {
  Grid,
  Paper,
  Typography,
  Button,
  LinearProgress,
} from "@material-ui/core/";

import { blue, purple, red, green } from "@material-ui/core/colors";

import { InventoryContext } from "../contexts/InventoryContext";

import InventoryItemList from "../components/InventoryItemList";
import InventoryManageItem from "../components/InventoryManageItem";
import InventoryItemDetails from "../components/InventoryItemDetails";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  noPadding: {
    padding: 0,
  },
  editItem: {
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: purple[500],
    "&:hover": {
      backgroundColor: purple[700],
    },
    "&:disabled": {
      backgroundColor: "grey",
    },
    borderColor: purple[700],
    minWidth: "max-content",
  },
  deleteItem: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700],
    },
    borderColor: red[700],
  },
  addItem: {
    color: theme.palette.getContrastText(blue[700]),
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700],
    },
    borderColor: blue[700],
  },
  viewItem: {
    color: theme.palette.getContrastText(green[700]),
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
    borderColor: green[700],
  },
}));

const Inventory = () => {
  const classes = useStyles();
  const {
    isLoading,
    getInventoryItems,
    getInventoryItemDetails,
    invItems,
    invItemDetails,
    setItemDetails,
  } = useContext(InventoryContext);
  const { isSuperAdmin } = useContext(AuthContext);
  const { isMobile } = useContext(ScreenContext);

  const [open, setOpen] = useState(false);
  const [formAction, setFormAction] = useState("New");
  const [selectedRowData, setselectedRowData] = useState(null);

  const [openDetails, setOpenDetails] = useState(false);

  const handleClickOpen = (action) => {
    setFormAction(action);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const handleViewDetails = () => {
    setItemDetails([]);
    getInventoryItemDetails(selectedRowData.id);
    setOpenDetails(true);
  };

  // useEffect(() => {
  //   console.log(selectedRowData);
  // }, [selectedRowData]);

  useEffect(() => {
    getInventoryItems();
  }, []);

  return (
    <React.Fragment>
      <Grid
        container
        alignItems="flex-start"
        justifyContent="space-between"
        spacing={2}
      >
        <Grid item xs={12}>
          <Typography variant="h3">Inventory</Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper style={{ padding: 10 }}>
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  variant="outlined"
                  size="small"
                  className={classes.addItem}
                  onClick={() => {
                    handleClickOpen("New");
                  }}
                >
                  Add Item
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  size="small"
                  className={classes.editItem}
                  disabled={selectedRowData ? false : true}
                  onClick={() => {
                    handleClickOpen("Edit");
                  }}
                >
                  Adjust Item
                </Button>
              </Grid>

              <Grid item>
                <Button
                  variant="outlined"
                  size="small"
                  disabled={selectedRowData ? false : true}
                  className={classes.viewItem}
                  onClick={handleViewDetails}
                >
                  Item Movement
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  size="small"
                  className={classes.deleteItem}
                  disabled={selectedRowData ? false : true}
                >
                  Delete Item
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper>
            {isLoading ? (
              <LinearProgress color="secondary" />
            ) : (
              <InventoryItemList
                setselectedRowData={setselectedRowData}
                dataRows={invItems}
              />
            )}
          </Paper>
        </Grid>
      </Grid>
      <InventoryManageItem
        open={open}
        handleClose={handleClose}
        formAction={formAction}
        selectedRowData={selectedRowData}
      />
      <InventoryItemDetails
        openDetails={openDetails}
        handleCloseDetails={handleCloseDetails}
        data={invItemDetails}
      />
    </React.Fragment>
  );
};

export default Inventory;
